<template>
  <el-card shadow="never">
    <table-view
      :table-model="tableModel1"
      :table-data="tableData1"
      :showPage="false"
    />
    <table-view
      :table-model="tableModel2"
      :table-data="tableData2"
      :showPage="false"
    />
    <div style="margin: 20px; border-top: 1px solid #ccc">
      <br />
      <Detail :details="LimitDetail" />
    </div>
  </el-card>
</template>

<script>
import { getCardResultDetail, getLimitDetail } from './api'
import Detail from './detail.vue'

export default {
  data() {
    return {
      tableModel1: [
        {
          label: 'Scorecard Name',
          prop: 'scoreCardName',
        },
        {
          label: 'Financial Year',
          prop: 'financialYear',
        },
      ],
      tableData1: [],
      tableModel2: [
        {
          minWidth: 200,
          label: 'Criteria Name',
          prop: 'criteriaName',
        },
        {
          width: 140,
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          width: 100,
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          width: 140,
          label: 'Weight',
          prop: 'weight',
        },
        {
          width: 140,
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableData2: [],
      LimitDetail: {},
    }
  },
  mounted() {
    this._getCardResultDetail()
  },
  methods: {
    async _getLimitDetail() {
      const data = await getLimitDetail(this.$route.params.customerId)
      this.LimitDetail = data
    },
    async _getCardResultDetail() {
      try {
        const {
          score = '',
          scoreCardName = '',
          financialYear = '',
          creditScoreCardCriteriaVOList,
          creditScoreLASVO,
          createTime,
        } = await getCardResultDetail(this.$route.params.id)
        if (scoreCardName === 'Lenovo MM Non Public Scorecard') {
          this._getLimitDetail()
        }
        if (scoreCardName === 'Lenovo LAS DS Scorecard') {
          this.tableModel1.push(
            {
              label: 'Required CL (USD)',
              prop: 'requiredCL',
            },
            {
              label: 'Submission Date',
              prop: 'createTime',
            },
          )
        }

        if (scoreCardName === 'Lenovo LAS Quick Test') {
          this.tableModel1.push({
            label: 'Submission Date',
            prop: 'createTime',
          })
        }
        this.tableData1.push({
          scoreCardName: scoreCardName,
          financialYear: financialYear,
          requiredCL: creditScoreLASVO?.requiredCL,
          createTime,
        })
        this.tableData2 = creditScoreCardCriteriaVOList

        this.tableData2.map(item => {
          const add$ = [
            'Lenovo Public Tot Equity',
            'Lenovo Public Working Capital',
            'Theoretical Limit',
          ]
          // if (
          //   item.criteriaName === 'Commercial Registry / Company Name Change'
          // ) {
          //   if (item.rawScore === '-25') {
          //     item.factorValue = 'Company name change ≤ 1.5 years'
          //   } else if (item.rawScore === '5') {
          //     item.factorValue = '1.5 years < Company name change ≤ 5 years'
          //   } else {
          //     item.factorValue = 'company name change > 5 years Or null'
          //   }
          // }

          if (item.criteriaName === 'DnB Payment History') {
            return item.factorValue
          }
          if (
            item.criteriaName === 'Protests/Financial Pending/Bank Refinance'
          ) {
            if (item.factorValue === '100.00') {
              item.factorValue = 'Capital Stock = 0 with Protests/Pefin/Refin'
            }
          }
          if (item.criteriaName === 'Lenovo/Moto Aged AR') {
            if (item.factorValue === '0.00') {
              item.factorValue = 'Past due = 0, blank'
            }
            if (item.factorValue === '-1.00') {
              item.factorValue = 'Total AR Balance <=0 ,blank'
            }
            if (item.rawScore === '10') {
              item.factorValue = 'Past Due = 0, Total AR Balance≠0'
            }
          }
          if (item.criteriaName === 'Capital Stock') {
            if (item.factorValue === '-1.00') {
              item.factorValue = 'greater than Credit Line Request'
            } else if (item.factorValue === '0.00') {
              item.factorValue = 'Capital = 0'
            } else if (
              item.factorValue >= '1.00' &&
              item.factorValue < '2.00'
            ) {
              item.factorValue = '100% to 200%'
            } else if (
              item.factorValue >= '2.00' &&
              item.factorValue < '3.00'
            ) {
              item.factorValue = '201% to 300%'
            } else if (
              item.factorValue >= '3.00' &&
              item.factorValue < '4.00'
            ) {
              item.factorValue = '301% to 400%'
            } else {
              item.factorValue = '>401%'
            }
          }
          if (add$.includes(item.criteriaName)) {
            item.criteriaName = item.criteriaName + ' ($)'
          }
          var regPos = /^\d+(\.\d+)?$/
          var regNeg =
            /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
          // if (regPos.test(item.factorValue) || regNeg.test(item.factorValue)) {
          //   item.factorValue = this.$utils.formatAmount(item.factorValue)
          // } else {
          //   return item.factorValue
          // }
          // if (regPos.test(item.rawScore) || regNeg.test(item.rawScore)) {
          //   item.rawScore = this.$utils.formatAmount(item.rawScore)
          // } else {
          //   return item.rawScore
          // }
          if (
            regPos.test(item.weightedScore) ||
            regNeg.test(item.weightedScore)
          ) {
            // item.weightedScore = this.$utils.formatAmount(item.weightedScore)
            // item.weightedScore = item.weightedScore
          } else {
            return item.weightedScore
          }
        })
        this.tableData2.push(creditScoreCardCriteriaVOList[23])
        this.tableData2.splice(23, 1)
        let str = ''
        if (scoreCardName === 'Lenovo LAS DS Scorecard') {
          str = `${score} (${creditScoreLASVO.scoreStr})`
        } else {
          str = score
        }
        this.tableData2.push({
          criteriaName: 'total',
          weightedScore: str,
        })
      } catch (e) {
        console.log(e)
      }
    },
  },
  components: {
    Detail,
  },
}
</script>

<style scoped></style>
